var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartOptions)?_c('app-chart',{attrs:{"chartType":"line","chartOptions":_vm.chartOptions,"height":170}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }